class LazyLoadSections {
  constructor() {
    this.sections = document.querySelectorAll('[data-lazy-section]');
    this.observer = null;
    this.init();
  }

  init() {
    if (!this.sections.length) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target;
          this.loadSection(section);
          this.observer.unobserve(section);
        }
      });
    }, {
      rootMargin: '100px 0px',
      threshold: 0.1
    });

    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  loadSection(section) {
    // Remove the loading placeholder if it exists
    const placeholder = section.querySelector('.section-placeholder');
    if (placeholder) {
      placeholder.remove();
    }

    // Add a class to indicate the section is loaded
    section.classList.add('section-loaded');
    
    // Initialize Shopify section if it exists
    if (typeof Shopify !== 'undefined' && Shopify.section) {
      Shopify.section.initialize(section);
    }

    // Trigger any necessary section-specific initialization
    if (typeof window.initSection === 'function') {
      window.initSection(section);
    }
  }
}

// Initialize when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new LazyLoadSections();
});

// Handle Shopify section updates
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  if (section.hasAttribute('data-lazy-section')) {
    new LazyLoadSections();
  }
}); 